"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleClearRowContent = exports.handleInsertRowBefore = exports.handleInsertRowAfter = exports.handleDuplicateRow = exports.handleDeleteRow = exports.handleAddRow = void 0;
var makeArrayFromLength_1 = require("../../../utils/makeArrayFromLength");
var genHash_1 = require("../utils/genHash");
var genNewRow = function (_a) {
    var data = _a.data, rowIdx = _a.rowIdx;
    var totCells = data[rowIdx].cellData.length;
    return ({
        id: "row_".concat((0, genHash_1.genHash)(8)),
        cellData: (0, makeArrayFromLength_1.makeArrayFromLength)(totCells).map(function (d, i) { return ({
            id: "cell_".concat((0, genHash_1.genHash)(8)),
        }); })
    });
};
var handleAddRow = function (value, props) {
    var onChange = props.onChange, id = props.id;
    var data = value.data, colWidthConfig = value.colWidthConfig;
    var newData = __spreadArray([], data, true);
    var lastRowIdx = newData.length - 1;
    var newRow = genNewRow({ data: newData, rowIdx: lastRowIdx });
    newData.push(newRow);
    onChange && onChange(id, { data: newData, colWidthConfig: colWidthConfig });
};
exports.handleAddRow = handleAddRow;
var handleDeleteRow = function (_a) {
    var value = _a.value, rowIdx = _a.rowIdx, onChange = _a.onChange, id = _a.id;
    var data = value.data, colWidthConfig = value.colWidthConfig;
    var newData = __spreadArray([], data, true);
    newData.splice(rowIdx, 1);
    onChange && onChange(id, { data: newData, colWidthConfig: colWidthConfig });
};
exports.handleDeleteRow = handleDeleteRow;
var handleDuplicateRow = function (_a) {
    var value = _a.value, rowIdx = _a.rowIdx, onChange = _a.onChange, id = _a.id;
    var data = value.data, colWidthConfig = value.colWidthConfig;
    var newData = __spreadArray([], data, true);
    var dataToDuplicate = __assign(__assign({}, newData[rowIdx]), { id: "row_".concat((0, genHash_1.genHash)(8)), cellData: newData[rowIdx].cellData.map(function (cell) { return (__assign(__assign({}, cell), { id: "cell_".concat((0, genHash_1.genHash)(8)) })); }) });
    newData.splice(rowIdx + 1, 0, dataToDuplicate);
    onChange && onChange(id, { data: newData, colWidthConfig: colWidthConfig });
};
exports.handleDuplicateRow = handleDuplicateRow;
var handleInsertRowAfter = function (_a) {
    var value = _a.value, rowIdx = _a.rowIdx, onChange = _a.onChange, id = _a.id;
    var data = value.data, colWidthConfig = value.colWidthConfig;
    var newData = __spreadArray([], data, true);
    var newRow = genNewRow({ data: newData, rowIdx: rowIdx });
    newData.splice(rowIdx + 1, 0, newRow);
    onChange && onChange(id, { data: newData, colWidthConfig: colWidthConfig });
};
exports.handleInsertRowAfter = handleInsertRowAfter;
var handleInsertRowBefore = function (_a) {
    var value = _a.value, rowIdx = _a.rowIdx, onChange = _a.onChange, id = _a.id;
    var data = value.data, colWidthConfig = value.colWidthConfig;
    var newData = __spreadArray([], data, true);
    var newRow = genNewRow({ data: newData, rowIdx: rowIdx });
    newData.splice(rowIdx, 0, newRow);
    onChange && onChange(id, { data: newData, colWidthConfig: colWidthConfig });
};
exports.handleInsertRowBefore = handleInsertRowBefore;
var handleClearRowContent = function (_a) {
    var value = _a.value, rowIdx = _a.rowIdx, onChange = _a.onChange, id = _a.id;
    var data = value.data, colWidthConfig = value.colWidthConfig;
    var newData = __spreadArray([], data, true);
    /**
     * this genNewRow does one very important thing apart from the obvious of clearing the value:
     * it creates a fresh new row id, which changes the 'react key' of the row being rendered, which
     * ensures the the RTE used within the cell is reinitiated and the previous value in it is cleared.
     * (since RTEs are not controlled components)
     */
    var newRow = genNewRow({ data: newData, rowIdx: rowIdx });
    newData.splice(rowIdx, 1, newRow);
    onChange && onChange(id, { data: newData, colWidthConfig: colWidthConfig });
};
exports.handleClearRowContent = handleClearRowContent;
